import { DEFAULT_SELECT_PAGE_SIZES } from '@/configs/constants';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../common/Select';
import { PaginationState } from '@tanstack/react-table';

interface SelectPageSizeProps {
    selectPageSizes?: number[],
    pageSize: number,
    setPagination: (pagination: PaginationState) => void
}

export default function SelectPageSize({ pageSize, setPagination, selectPageSizes = DEFAULT_SELECT_PAGE_SIZES }: SelectPageSizeProps) {
    // hooks
    return (
        <Select
            value={pageSize.toString()}
            onValueChange={(page: string) => {
                setPagination({
                    pageIndex: 0,
                    pageSize: Number(page)
                });
            }}
        >
            <SelectTrigger className='w-[180px] h-[40px] bg-bgInput border-none text-txtHolder'>
                <SelectValue />
            </SelectTrigger>
            <SelectContent>
                {
                    selectPageSizes.map(size => (
                        <SelectItem key={size} value={size.toString()}>
                            表示件数
                            {' '}
                            {size}
                        </SelectItem>
                    ))
                }
            </SelectContent>
        </Select>
    );
}
